import Svg from "@/components/Svg";

const CirclePath = ({ color }) => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M40 76.7568C60.3002 76.7568 76.7568 60.3002 76.7568 40C76.7568 19.6998 60.3002 3.24324 40 3.24324C19.6998 3.24324 3.24324 19.6998 3.24324 40C3.24324 60.3002 19.6998 76.7568 40 76.7568ZM40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
    fill={color}
  />
);

export default function OrangeIcon({ size = 40, withCircle = true, color }) {
  const viewBox = withCircle ? "0 0 80 80" : "0 0 30 30";
  const iconTransform = withCircle ? "translate(10 10) scale(2)" : "";

  return (
    <Svg
      as="svg"
      width={size}
      height={size}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {withCircle && <CirclePath color={color} />}
      <g transform={iconTransform}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.9999 16.6436C13.9087 19.4832 12.3799 23.1956 12.3799 24.5064C12.3799 25.8176 13.0349 27.127 14.9999 27.127C16.965 27.127 17.6202 25.8161 17.6202 24.5064C17.6202 23.1956 16.0912 19.4832 14.9999 16.6436Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.1565 16.1623C17.391 18.9418 18.9353 22.6476 19.8614 23.5747C20.7876 24.5014 22.1771 24.9651 23.5662 23.5747C24.9557 22.1844 24.4925 20.7953 23.5662 19.8682C22.64 18.9413 18.9348 17.3974 16.1562 16.1621L16.1565 16.1623Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.8436 16.1631C11.0648 17.3984 7.35965 18.9425 6.43337 19.8694C5.50733 20.7963 5.04419 22.1854 6.43337 23.5757C7.82279 24.966 9.21221 24.5026 10.1382 23.5757C11.0645 22.6486 12.6089 18.9425 13.8434 16.1633L13.8436 16.1631Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.4981 12.3848C23.1881 12.3848 19.4765 13.9133 16.6377 15.0053C19.4765 16.0973 23.1881 17.6259 24.4981 17.6259C25.8082 17.6259 27.1182 16.9704 27.1182 15.0053C27.1182 13.0402 25.8082 12.3848 24.4981 12.3848Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.88184 15.0053C2.88184 16.9704 4.19187 17.6259 5.5019 17.6259C6.81217 17.6259 10.5235 16.0973 13.3623 15.0053C10.5235 13.9133 6.81217 12.3848 5.5019 12.3848C3.43971 12.4308 2.90726 13.9414 2.88184 15.0053Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.8611 6.42586C18.9348 7.35274 17.3907 11.0591 16.1562 13.8383C18.9351 12.6027 22.64 11.0588 23.5662 10.1319C24.4925 9.20482 24.9557 7.81594 23.5662 6.42562C22.4265 5.2837 21.0126 5.25298 19.8614 6.42562L19.8611 6.42586Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.43355 6.42563C5.04413 7.81595 5.50727 9.20507 6.43355 10.132C7.35983 11.0591 11.0649 12.6028 13.8438 13.8383C12.6091 11.0591 11.0649 7.35275 10.1387 6.42587C8.72646 5.07155 7.4277 5.45435 6.43379 6.42587L6.43355 6.42563Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.0002 2.88281C13.0351 2.88281 12.3799 4.19369 12.3799 5.50337C12.3799 6.81425 13.9089 10.5268 15.0002 13.3663C16.0915 10.5268 17.6202 6.81425 17.6202 5.50337C17.6202 4.19249 16.9652 2.88281 15.0002 2.88281Z"
          fill={color}
        />
      </g>
    </Svg>
  );
}
